export default __webpack_public_path__ + "static/media/icon_person_ability_white.42deb1a6.svg";